import { TooltipProps } from 'recharts'
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent'
import styles from './Charts.module.scss'
import { NumericFormat } from 'react-number-format'


export const CustomTooltip = (props: TooltipProps<ValueType, NameType>) => {
    const { active, payload } = props

    if (active && payload && payload.length) {
        const { date, before, after, revenueDiff } = payload[0].payload
        const fullDate = date.split(" ").map((word: string, index: number) => index === 0 ? new Date(date).toLocaleString('default', { month: 'long' }) : '20' + word).join(" ")

        return (
            <div className={styles.tooltip}>
                <p className={styles.date}>{fullDate}</p>
                <p className={styles.intro}> <span className={styles.currentWebsite}>After:</span>
                    <NumericFormat style={{ background: 'inherit', color: '#54857c', border: 'none' }} prefix='$' thousandSeparator={true} value={before} />
                </p>
                <p className={styles.intro}> <span className={styles.newWebsite}>Before:</span>
                    <NumericFormat style={{ background: 'inherit', color: '#fad865', border: 'none' }} prefix='$' thousandSeparator={true} value={after} />
                </p>
                <p className={styles.intro}>
                    Net revenue difference:
                    <span className={styles.difference}>
                        {`${revenueDiff > 0 ? '+$' : '-$'}`}
                        <NumericFormat style={{ background: 'inherit', color: 'inherit', border: 'none' }}
                            thousandSeparator={true} value={Math.abs(revenueDiff)} />
                    </span>
                </p>
            </div>
        )
    }

    return null
}
